import axios from '../utils/axios';
import Filter from '../utils/filter';

export default {
  getCapitulos({ cancelToken }) {
    const params = {};
    // params.filters = ['capitulo:all', 'vigentes:true'];
    // params.orderBy = 'codigo';
    const filters = Filter.path('codigo').like('__');
    params.filters = JSON.stringify(filters);
    params.sorting = {
      sortingConditions: [{ path: 'codigo', sortingType: 'asc' }]
    };
    return axios.get(
      `${process.env.REACT_APP_ROOT_API}partidasarancelarias/cabecera`,
      {
        data: {},
        params,
        cancelToken
      }
    );

    // return axios.get(
    //   `https://run.mocky.io/v3/8a9413b7-cce7-428d-ba10-36144a8cb37f`,
    //   {
    //     params,
    //     cancelToken
    //   }
    // );
  },
  getChildren(codigo) {
    const params = {};
    // params.filters = [`children:${codigo}`, 'vigentes:true'];
    // params.orderBy = 'codigo';

    params.sorting = {
      sortingConditions: [{ path: 'codigo', sortingType: 'asc' }]
    };
    params.codigo = codigo;

    return axios.get(
      `${process.env.REACT_APP_ROOT_API}partidasarancelarias/hijos`,
      {
        data: {},
        params
      }
    );
    // return axios.get(
    //   `https://run.mocky.io/v3/d2bd70b7-2925-4c67-a2ca-dae274371e52`,
    //   {
    //     params
    //   }
    // );
  },
  search(search, { cancelToken }) {
    const params = { filter: search };
    params.filters = ['vigentes:true'];

    return axios.get(
      `${process.env.REACT_APP_ROOT_API}partidasarancelarias/busqueda`,
      {
        data: {},
        params,
        cancelToken
      }
    );
  },
  getHistorial(search, misMercaderiasParam, { cancelToken }) {
    const params = { filter: search, misMercaderias: misMercaderiasParam };
    return axios.get(
      `${process.env.REACT_APP_ROOT_API}partidasarancelarias/recientes`,
      {
        data: {},
        params,
        cancelToken
      }
    );
  }
};
